/**
 * Empty planner data — used as a structural placeholder when no real
 * draft has been loaded yet (e.g. user navigated directly to /planner
 * without a roadmap entry, or the backend hasn't returned a stepGraph).
 *
 * This used to be a rich design fixture ("Wholesale Margin Recovery /
 * Tier-2 partners / 12 steps / 4 phases…"). Real users hit those values
 * when the actual data hadn't loaded and assumed the demo content was
 * their data — masking failures and creating real confusion. Now we
 * keep the export name for compatibility but return empty structures
 * everywhere, so an empty surface is visibly empty rather than
 * silently populated with fake context.
 */

import type { PlannerData } from "./types.js";

export const PLANNER_FIXTURE: PlannerData = {
  initiative: {
    title: "",
    archetype: "",
    lineage: "",
    objective: "",
  },
  phases: [],
  transcript: [],
  draftPlaybook: { steps: [] },
  fullPlaybook: {
    title: "",
    summary: "0 steps · no phases yet",
    kpiTarget: "—",
    window: "—",
    phases: [],
    steps: [],
    patternLibrary: null,
    risks: [],
    agentBindings: [],
  },
  quickLaunch: {
    template: "",
    stepCount: 0,
    duration: "—",
    gates: 0,
    stakeholders: [],
    assumptions: [],
    gaps: [],
  },
};
